<template>
  <div class="container bottom-fix-padding">
    <v-suburb v-show="pickSuburbIf" @change="changePickSuburb" @close="pickClose()"></v-suburb>
    <v-suburb v-show="returnSuburbIf" @change="changeReturnSuburb" @close="returnClose()"></v-suburb>

    <div class="core" v-show="!pickSuburbIf&&!returnSuburbIf">
      <div class="navi">
          <span class="icon-arrow-left" @click="goto('/storage-step3')"></span>
      </div>
      <div class="title">请填写服务地址</div>
      <div class="main">
          <div class="core">
            <div>
                <div class="weui-cells__title big">取货地址</div>
                <div class="weui-cells weui-cells_form" >
                    <div class="weui-cell">
                        <div class="weui-cell__hd"><label class="weui-label">Street</label></div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="text" placeholder="如: Unit 2, 9 Hunter St" v-model="order.data.pick_street">
                        </div>
                    </div>
                    <div class="weui-cell weui-cell_access padding-fix"  @click="pickSelect()">
                        <div class="weui-cell__hd">
                            <label class="weui-label">Suburb</label>
                        </div>
                        <div class="weui-cell__bd" v-if="order.data.pick_suburb==''"> 
                            <p class="placeholder-color">如: Chatswood</p>
                        </div>
                        <div class="weui-cell__bd" v-if="order.data.pick_suburb!=''"> 
                            <p>{{order.data.pick_suburb}}</p>
                        </div>
                        <div class="weui-cell__ft"></div>
                    </div>
                    <div class="weui-cell weui-cell_select weui-cell_select-after">
                        <div class="weui-cell__hd"><label class="weui-label">State</label></div>
                        <div class="weui-cell__bd">
                            <select class="weui-select" name="select2" >
                                <option value="NSW" selected>NSW</option>
                            </select>
                        </div>
                    </div>
                    <div class="weui-cell" >
                        <div class="weui-cell__hd"><label class="weui-label">Postcode</label></div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="text"  placeholder="如：2000" v-model="order.data.pick_postcode">
                        </div>
                    </div>
                </div>
                <div class="weui-cells__title big to-return">送回地址</div>
                <div class="weui-cells weui-cells_checkbox">
                    <label class="weui-cell weui-check__label" for="s11">
                        <div class="weui-cell__hd">
                            <input type="radio" class="weui-check" name="checkbox1" id="s11" value="0" v-model="order.data.return_pending">
                            <i class="weui-icon-checked"></i>
                        </div>
                        <div class="weui-cell__bd">
                            <p>跟取货地址相同</p>
                        </div>
                    </label>
                    <label class="weui-cell weui-check__label" for="s12" @click="scrollToReturn()">
                        <div class="weui-cell__hd">
                            <input type="radio" name="checkbox1" class="weui-check" id="s12" value="2" v-model="order.data.return_pending">
                            <i class="weui-icon-checked"></i>
                        </div>
                        <div class="weui-cell__bd">
                            <p>跟取货地址不同，我要填写另一个地址</p>
                        </div>
                    </label>
                    <label class="weui-cell weui-check__label" for="s13">
                        <div class="weui-cell__hd">
                            <input type="radio" name="checkbox1" class="weui-check" id="s13" value="1" v-model="order.data.return_pending">
                            <i class="weui-icon-checked"></i>
                        </div>
                        <div class="weui-cell__bd">
                            <p>暂时无法确定，送回前我再联系客服</p>
                        </div>
                    </label>
                </div>
                
                <div v-show="order.data.return_pending=='2'">
                  <div class="weui-cells weui-cells_form" >
                      <div class="weui-cell">
                          <div class="weui-cell__hd"><label class="weui-label">Street</label></div>
                          <div class="weui-cell__bd">
                              <input class="weui-input" type="text" placeholder="如: Unit 2, 9 Hunter St" v-model="order.data.return_street">
                          </div>
                      </div>
                      <div class="weui-cell weui-cell_access padding-fix"  @click="returnSelect()">
                          <div class="weui-cell__hd">
                              <label class="weui-label">Suburb</label>
                          </div>
                          <div class="weui-cell__bd" v-if="order.data.return_suburb==''"> 
                              <p class="placeholder-color">如: Chatswood</p>
                          </div>
                          <div class="weui-cell__bd" v-if="order.data.return_suburb!=''"> 
                              <p>{{order.data.return_suburb}}</p>
                          </div>
                          <div class="weui-cell__ft"></div>
                      </div>
                      <div class="weui-cell weui-cell_select weui-cell_select-after">
                          <div class="weui-cell__hd"><label class="weui-label">State</label></div>
                          <div class="weui-cell__bd">
                              <select class="weui-select" name="select2" >
                                  <option value="NSW" selected>NSW</option>
                              </select>
                          </div>
                      </div>
                      <div class="weui-cell" >
                          <div class="weui-cell__hd"><label class="weui-label">Postcode</label></div>
                          <div class="weui-cell__bd">
                              <input class="weui-input" type="text"  placeholder="如：2000" v-model="order.data.return_postcode">
                          </div>
                      </div>
                  </div>
                </div>
            </div>
        </div>

      </div>
      <div class="btn-box-fix">
        <div class="btn-container">
          <div class="btn" @click="checkSubmit()" :class="{ active: allFilled()}" >下一步</div>
        </div>
      </div>
      <div v-show="localErrorShow">
          <div class="weui-mask"></div>
          <div class="weui-dialog">
              <div class="weui-dialog__bd">{{localError[0]}}</div>
              <div class="weui-dialog__ft">
                  <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="localErrorShow=false">好的</a>
              </div>
          </div>
      </div>
      
    </div>

    <img :src="pixelURL('cangchu','step4')" class="hide">
  </div>
</template>

<script>
import anime from 'animejs';

export default {
  name: 'step4',
  data () {
    return {
      returnSuburbIf:false,
      pickSuburbIf:false,
      localError:[],
      localErrorShow:false,
      order:{
      }
    }
  },
  created: function () {
    document.querySelector("html").classList.add("grey-background");
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "storage"){
        this.order = localParsed;
      }
      else{
        this.$router.push('/');
      }
    }
    else{
      this.$router.push('/');
    }
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  },
  methods: {
    allFilled(){
       if(this.order.data.username &&
          this.order.data.userphone &&
          this.order.data.pick_date &&
          this.order.data.baggage){
            return true;
        }
    },
    checkSubmit(){
      this.localError = [];
      if (!this.order.data.pick_street) {
        this.localError.push("请填写取货 Street 地址");
      } else if (this.order.data.pick_street.length<8) {
        this.localError.push("取货 Street 地址长度太短，请检查是否正确");
      } else if (this.order.data.pick_street.length>40) {
        this.localError.push("取货 Street 地址长度太长，请检查是否正确");
      }
      if (!this.order.data.pick_suburb) {
        this.localError.push("请选择取货地址 Suburb");
      }
      if (!this.order.data.pick_postcode) {
        this.localError.push("请填写4位取货地址 Postcode 号码1");
      } else if (this.order.data.pick_postcode.length!=4) {
        this.localError.push("请填写4位取货地址 Postcode 号码2");
      }
      if(!this.order.data.return_pending){
        this.localError.push("请填写行李送回地址");
      }
      if(this.order.data.return_pending=='2'){
        if (!this.order.data.return_street) {
          this.localError.push("请填写送回 Street 地址");
        } else if (this.order.data.return_street.length<8) {
          this.localError.push("送回 Street 地址长度太短，请检查是否正确");
        } else if (this.order.data.return_street.length>40) {
          this.localError.push("送回 Street 地址长度太长，请检查是否正确");
        }
        if (!this.order.data.return_postcode) {
          this.localError.push("请填写4位送回地址 Postcode 号码");
        } else if (this.order.data.return_postcode.length!=4) {
          this.localError.push("请填写4位送回地址 Postcode 号码");
        }
        if (!this.order.data.return_suburb) {
          this.localError.push("请选择送回地址 Suburb");
        }
      }
      if (!this.localError.length) {
        this.orderUpdateAll('/storage-step5');
      }
      else{
        this.localErrorShow = true;
        return false;
      }
    },
    scroll(arg) {
        let el = document.querySelector(arg.to),
            offset = parseInt(arg.offset) || 0,
            duration = arg.duration || 1500,
            easing = arg.easing || 'easeInOutQuart',
            callback = arg.callback || null;

        if ( el ) {
            anime({
                targets: ['html', 'body'],
                scrollTop: (el.offsetTop - offset),
                duration: duration,
                easing: easing,
                complete: callback
            })
            .finished.then(() => {
                this.$emit('scroll:finished', true);
            });
        }
    },
    scrollToReturn(){
        this.scroll({ 
            to: '.to-return'
        });
    },
    sleep (time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    },
    pickSelect: function() {
        this.rememberTop = window.scrollY;
        this.pickSuburbIf=true;
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    },
    returnSelect: function() {
        this.rememberTop = window.scrollY;
        this.returnSuburbIf=true;
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    },

    changePickSuburb: function(suburb,postcode) {
        this.order.data.pick_suburb = suburb;
        this.order.data.pick_postcode = postcode.toString();
        this.sleep(10).then(() => {
            document.documentElement.scrollTop = this.rememberTop;
            document.body.scrollTop = this.rememberTop;
        });
        this.pickSuburbIf=false;
    },
    pickClose: function() {
        this.sleep(10).then(() => {
            document.documentElement.scrollTop = this.rememberTop;
            document.body.scrollTop = this.rememberTop;
        });
        this.pickSuburbIf=false;
    },

    changeReturnSuburb: function(suburb,postcode) {
        this.order.data.return_suburb = suburb;
        this.order.data.return_postcode = postcode.toString();
        this.sleep(10).then(() => {
            document.documentElement.scrollTop = this.rememberTop;
            document.body.scrollTop = this.rememberTop;
        });
        this.returnSuburbIf=false;
    },
    returnClose: function() {
        this.sleep(10).then(() => {
            document.documentElement.scrollTop = this.rememberTop;
            document.body.scrollTop = this.rememberTop;
        });
        this.returnSuburbIf=false;
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.hr{
  border-top:1px solid #eee;
  margin:16pt 0;
}
.address-empty{
  color:#ccc;
  font-size:1.2em;
}

.container /deep/ .weui-cells__title.big{
  color:#666;
  font-size:18px;
  margin-top:20px;
}

.address-detail{
  color:#666;
  font-size:1.1em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.address-parking{
  color:#aaa;
  font-size:1em;
}

.arrow-right{
  color:#ddd;
}
.move-title{
  font-weight:bold;
  font-size:1.2em;
  color:#555;
  margin-bottom:4pt;
}

.waypoint{
  font-weight:bold;
  font-size:1.2em;
  color:#777;
  margin-bottom:4pt;
}

select{
  -webkit-appearance: none;
  border: 0;
  outline: 0;
  background-color: transparent;
  width: 100%;
  font-size: inherit;
  height: 45px;
  line-height: 45px;
  position: relative;
  z-index: 1;
}

.fade-enter-active{
  transition-duration: 0.5s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.check-detail{
  border: 2px solid #e3e3e3;
  padding: 8px 18px 8px 14px;
  margin-top: 14px;
  display: inline-block;
  border-radius: 50px;
}

.more-detail{
  text-align:center;
  margin-bottom:20px;
}

</style>



// WEBPACK FOOTER //
// src/pages/storage/step4.vue